import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable, Subject } from 'rxjs';
import { IUser } from '../interfaces/Users';
import { IUserRights } from '../interfaces/UserRights';
import { IUserRightsDetails } from '../interfaces/UserRightsDetails';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpHeaders,HttpClient } from '@angular/common/http';
import { config } from '../../config';


@Injectable()
export class UserService {
    constructor(private http: Http,private httpClient:HttpClient) { }   

    baseUrl = config.apiUrl;


    getHeaders(): HttpHeaders {         
        let headers = new HttpHeaders();                  
        headers.append('Content-Type', 'application/json');
         return headers;
   }  
    
     // This API used when we login into release management (Azure AD token not pass in this API)
     getUsers(EmailId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'user/getuserdata/' + EmailId, { headers: this.getHeaders() })
            .map((response: Response) => {
                return response;
            })
    }
    
    getUsersByData(EmailId,UserId): Observable<any> {
        return this.httpClient.get(this.baseUrl + 'user/GetUserByData/' + EmailId + '/' + UserId, { headers: this.getHeaders() })
        .map((response: Response) => {            
            return response;
        })       
    }  

    getUser(): Observable<IUser> {                
        return this.httpClient.get(this.baseUrl + 'user/getusers/', { headers: this.getHeaders() })
        .map(response => {
            return response  as IUser;
        })       
    }    


    getUserById(UserId): Observable<any> {                
        return this.httpClient.get(this.baseUrl + 'user/getusersbyid/'+ UserId, { headers: this.getHeaders() })
        .map(response => {
            return response as IUser;
        })       
    }    

     // Add Application Name and Code
     addUser(UserData: any): Observable<any> {           
        return this.httpClient.post(this.baseUrl +'user/v2/addUser',  UserData, { headers: this.getHeaders() })
        .map((response: Response) => {            
            return response;
        })       
    }
    
    updateUser(UserData: any): Observable<any> {           
        return this.httpClient.post(this.baseUrl +'user/v2/updateUser',  UserData,{ headers: this.getHeaders() })
        .map((response: Response) => {                        
            return response
        })       
    }

    getUserRights(UserId): Observable<any> {                
        return this.httpClient.get(this.baseUrl + 'user/getusersrights/'+ UserId, { headers: this.getHeaders() })
        .map(response => {
            return response;
        })       
    }  

    getUserAllRightsById(UserId):Observable<any>{
        return this.httpClient.get(this.baseUrl+'user/v2/getusersrights/'+UserId,{headers:this.getHeaders()}).map((response)=>{
            return response;
        })
    }
    getUserRightsById(UserId,InstumentTypeMasterId): Observable<any> {         
               
        return this.httpClient.get(this.baseUrl + 'user/getusersrightsbyid/'+ UserId +'/'+  InstumentTypeMasterId, { headers: this.getHeaders() })
        .map(response => {    
                    
            return response as IUserRights;
        })       
    }  
    getUserLicenseRightById(userId,productId):Observable<any>{
        return this.httpClient.get(this.baseUrl+'user/v2/getUserLicenseRightByProductId/'+userId+'/'+productId,{headers:this.getHeaders()}).map((response)=>{
            return response;
        })
    }

    getUserRightsDetaisSummaryById(UserId): Observable<any> {                
        return this.httpClient.get(this.baseUrl + 'user/getuserreightsummary/'+ UserId, { headers: this.getHeaders() })
        .map(response => {            
            return response as IUserRightsDetails;
        })       
    }  
   
   
    private notify = new Subject<any>();
    notifyObservable$ = this.notify.asObservable();
    public notifyOther(data: any) {
        if (data) {
            this.notify.next(data);
        }
    }
}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/services/UserService.ts